import script from "./czeyOrderRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./czeyOrderRecord.vue?vue&type=script&setup=true&lang=js"

import "./czeyOrderRecord.vue?vue&type=style&index=0&id=72988c0a&lang=scss"

const __exports__ = script;

export default __exports__